<div>
  <mat-chip-set>
    <mat-chip
      class="chip"
      [ngStyle]="{ 'background-color': c.isSuggested ? 'rgba(226, 78, 127, 0.05)' : '#fffff' }"
      *ngFor="let c of chips"
      (removed)="removeChip($event)"
      [value]="c">
      <span *ngIf="c?.type === 'Company Name'" class="mr-1">
        <span class="compnaylogoplaceholder-chip">
          <img [src]="c?.companylogo" *ngIf="c?.companylogo" class="img-fluid" alt="">
          <i class="fas fa-building f-12" *ngIf="!c?.companylogo"></i>
      </span>
      </span>
      <span class="text-truncate mr-1" [matTooltip]="c.name | titlecase" matTooltipPosition="above" matTooltipClass="ai-tooltip" style="font-weight: 400;">{{c.name | titlecase}}</span>
      <i class="fa-thumbtack pointer" *ngIf="c.canStar"
        [matTooltip]="!c.starred ? 'Mark this as High Priority' : ''"
        matTooltipPosition="above"
        matTooltipClass="ai-tooltip"
        [ngClass]="{ 'fas text-webbtree-green': c.starred, fal: !c.starred }"
        (click)="toggleStar(c)"></i>
        <span matChipRemove>
          <i class="fas fa-times"></i>
       </span>
    </mat-chip>
  </mat-chip-set>
</div>
